import React from 'react';
import { Control } from 'react-hook-form';
import { FormTextarea } from '../components/shared/FormTextarea';
import { TagInput } from '../components/shared/TagInput';
import { OnboardingData } from '../types';

interface Step3CompetitiveLandscapeProps {
  control: Control<OnboardingData>;
}

const Step3CompetitiveLandscape: React.FC<Step3CompetitiveLandscapeProps> = ({
  control
}) => {
  return (
    <div className="space-y-6">
      {/* Question 1: Competitors */}
      <div>
        <label className="block text-body-form-label text-text font-medium mb-3">
          Who are your competitors?
        </label>
        <TagInput
          name="step3_competitiveLandscape.competitors"
          control={control}
          placeholder="Add competitor... (press Enter or comma)"
          rules={{
            validate: (value: string[]) => {
              if (!value || value.length < 1) {
                return 'Please add at least 1 competitor';
              }
              return true;
            }
          }}
        />
      </div>

      {/* Question 2: Differentiation */}
      <div>
        <FormTextarea
          name="step3_competitiveLandscape.differentiation"
          control={control}
          label="How are you different than your competitors?"
          placeholder="Describe what sets you apart from your competition..."
          rows={2}
          rules={{ required: 'This field is required' }}
        />
      </div>
    </div>
  );
};

export { Step3CompetitiveLandscape };